// src/modules/gerenciador/AvaliacaoDashboard.js
import React, { useState, useEffect, useMemo } from 'react';
import { db, paths } from '../../firebase/config';
import { collection, query, where, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, onSnapshot, writeBatch, getDocs } from "firebase/firestore";
import { useAuth, logAuditoria } from '../../context/AuthContext';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';

// Importação do Recharts para os gráficos
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const COLORS = ['#4F46E5', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#14B8A6', '#F43F5E', '#3B82F6'];

// ==================== ÍCONES ====================
const ChartIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" /></svg>;
const UserGroupIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const PlusIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>;
const SearchIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>;
const PrinterIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>;
const TrashIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
const RefreshIcon = ({ className = "w-6 h-6" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.926 8.926 0 0112 21a9 9 0 01-5.6-3.2m15.356-2A8.926 8.926 0 0012 3a9 9 0 00-5.6 3.2" /></svg>;
const LockClosedIcon = ({ className = "w-6 h-6" }) => <svg className={className || "w-4 h-4"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>;
const UnlockIcon = ({ className = "w-6 h-6" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" /></svg>;
const DotsIcon = () => <svg className="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 12h.01M12 12h.01M19 12h.01M6 12a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const DownloadIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>;
const ChatIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>;
const BellIcon = () => <svg className="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>;
const GearIcon = () => <svg className="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const DashboardIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>;
const ChartBarIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>;
const CalendarIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
const AlertCircleIcon = ({ className = "w-6 h-6" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const DocumentIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const SortIcon = ({ active, direction }) => (
    <svg className={`w-3 h-3 inline-block ml-1 transition-transform ${active ? 'text-blue-600' : 'text-slate-300'} ${direction === 'asc' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
    </svg>
);
const XIcon = ({ className = "w-6 h-6" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);
const CollectionIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg>
);
const CheckCircleOutlineIcon = ({ className = "w-12 h-12" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
);
const MenuIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
);

const DotBadge = ({ dotColor, text }) => (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-slate-200 text-slate-600 font-medium text-xs bg-white shadow-sm whitespace-nowrap">
        <span className={`w-2 h-2 rounded-full ${dotColor}`}></span>
        {text}
    </span>
);

export const AvaliacaoDashboard = () => {
    const { userProfile } = useAuth();
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('resultados'); 
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Abas
    const [selectedTurmaPendencia, setSelectedTurmaPendencia] = useState('');
    const [selectedPelotoes, setSelectedPelotoes] = useState({});
    
    // Filtros
    const [filterProfessor, setFilterProfessor] = useState('');
    const [selectedCursoResult, setSelectedCursoResult] = useState('');
    const [selectedTurmaResult, setSelectedTurmaResult] = useState('');
    const [selectedMateriaResult, setSelectedMateriaResult] = useState('');
    
    // Controles do Drawer Lateral e Modais
    const [expandedTeacherId, setExpandedTeacherId] = useState(null);
    const [expandedAssessmentId, setExpandedAssessmentId] = useState(null);
    const [expandedImage, setExpandedImage] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'mediaFinal', direction: 'desc' });
    const [showCommentsModal, setShowCommentsModal] = useState(false);

    // Controle do modal de impressão do dossiê
    const [showDossieModal, setShowDossieModal] = useState(false);
    const [selectedDossieRes, setSelectedDossieRes] = useState(null);

    // Dados Firebase
    const [ciclos, setCiclos] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [respostas, setRespostas] = useState([]);
    const [alunos, setAlunos] = useState([]);

    // Modais
    const [showModal, setShowModal] = useState(false);
    const [formCiclo, setFormCiclo] = useState({ titulo: '', curso_nome: '', turma_id: '', professores_ids: [], ativo: true, data_inicio: '', data_fim: '' });
    
    const [showEditCicloModal, setShowEditCicloModal] = useState(false);
    const [editCicloData, setEditCicloData] = useState({ id: '', titulo: '', data_fim: '' });

    const [processing, setProcessing] = useState(false);
    const [actionMenuOpenId, setActionMenuOpenId] = useState(null);

    // ==================== HELPERS ====================
    const isCicloRealmenteAtivo = (ciclo) => ciclo.ativo === true;

    const getStatusCiclo = (ciclo) => {
        if (!ciclo.ativo) return { text: 'Encerrado (Manual)', dot: 'bg-red-500', Icon: LockClosedIcon };
        const hoje = new Date();
        const inicio = ciclo.data_inicio ? new Date(ciclo.data_inicio) : null;
        const fim = ciclo.data_fim ? new Date(ciclo.data_fim) : null;

        if (inicio && inicio > hoje) return { text: 'Agendado', dot: 'bg-amber-400', Icon: CalendarIcon };
        if (fim && fim < hoje) return { text: 'Encerrado (Prazo)', dot: 'bg-slate-400', Icon: LockClosedIcon };
        return { text: 'Aberto', dot: 'bg-emerald-500', Icon: UnlockIcon };
    };

    const renderProgressBar = (label, value) => {
        const num = Number(value) || 0;
        const percent = (num / 10) * 100;
        let color = 'bg-red-400';
        if(num >= 7) color = 'bg-blue-400';
        if(num >= 9) color = 'bg-emerald-400';

        return (
            <div className="flex flex-col gap-1.5 w-full">
                <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-500 font-medium">{label}</span>
                    <span className="font-semibold text-slate-700">{Number(num).toFixed(2)}/10</span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-1.5 border border-slate-200/60 overflow-hidden">
                    <div className={`${color} h-1.5 rounded-full transition-all duration-500`} style={{ width: `${percent}%` }}></div>
                </div>
            </div>
        )
    };

    // ==================== FILTROS E MEMOS ====================
    const mapAlunosGlobais = useMemo(() => {
        const mapa = {};
        alunos.forEach(a => { mapa[a.id] = a; });
        return mapa;
    }, [alunos]);

    const cursosDisponiveis = useMemo(() => {
        const cursos = new Set();
        professores.forEach(prof => {
            if (prof.aulas && Array.isArray(prof.aulas)) {
                prof.aulas.forEach(aula => {
                    if (aula.curso_nome) cursos.add(aula.curso_nome);
                });
            }
        });
        return Array.from(cursos).sort();
    }, [professores]);

    const professoresFiltrados = useMemo(() => {
        if (!formCiclo.curso_nome) return [];
        return professores.filter(p => 
            p.aulas && p.aulas.some(aula => aula.curso_nome === formCiclo.curso_nome)
        );
    }, [professores, formCiclo.curso_nome]);

    const profsOcupadosNoCurso = useMemo(() => {
        const ocupados = new Set();
        ciclos.filter(isCicloRealmenteAtivo).forEach(ciclo => {
            if (ciclo.professores_ids) {
                ciclo.professores_ids.forEach(id => {
                    if (ciclo.curso_nome) ocupados.add(`${id}_${ciclo.curso_nome}`);
                    else ocupados.add(`${id}_legacy`);
                });
            }
        });
        return ocupados;
    }, [ciclos]);

    // --------- PENDÊNCIAS ---------
    const pendenciasAgrupadas = useMemo(() => {
        const grupos = {};
        const ciclosRelevantes = ciclos.filter(isCicloRealmenteAtivo);
        
        const mapRespostas = {};
        respostas.forEach(r => {
            if (!mapRespostas[r.ciclo_id]) mapRespostas[r.ciclo_id] = {};
            mapRespostas[r.ciclo_id][r.cadete_id] = (mapRespostas[r.ciclo_id][r.cadete_id] || 0) + 1;
        });

        ciclosRelevantes.forEach(ciclo => {
            const turmaNome = ciclo.turma_nome || "Turma Desconhecida";
            const alunosDaTurma = alunos.filter(a => String(a.turma_id) === String(ciclo.turma_id));
            const totalProfessores = ciclo.professores_ids ? ciclo.professores_ids.length : 0;
            
            if (totalProfessores === 0) return;

            const cicloRespostas = mapRespostas[ciclo.id] || {};

            alunosDaTurma.forEach(aluno => {
                const qtdFeitas = cicloRespostas[aluno.id] || 0;
                if (qtdFeitas < totalProfessores) {
                    const pelotaoNome = aluno.pelotao_nome || "Sem Pelotão";
                    if (!grupos[turmaNome]) grupos[turmaNome] = {};
                    if (!grupos[turmaNome][pelotaoNome]) grupos[turmaNome][pelotaoNome] = [];
                    
                    grupos[turmaNome][pelotaoNome].push({
                        id: aluno.id, nome: aluno.nome, re: aluno.matricula || 'N/D',
                        faltam: totalProfessores - qtdFeitas, total: totalProfessores
                    });
                }
            });
        });
        
        const ordenado = {};
        Object.keys(grupos).sort().forEach(turma => {
            ordenado[turma] = {};
            Object.keys(grupos[turma]).sort().forEach(pelotao => {
                ordenado[turma][pelotao] = grupos[turma][pelotao].sort((a,b) => a.nome.localeCompare(b.nome));
            });
        });
        return ordenado;
    }, [ciclos, alunos, respostas]);

    useEffect(() => {
        const turmas = Object.keys(pendenciasAgrupadas);
        if (turmas.length > 0 && (!selectedTurmaPendencia || !turmas.includes(selectedTurmaPendencia))) {
            setSelectedTurmaPendencia(turmas[0]);
        }
    }, [pendenciasAgrupadas, selectedTurmaPendencia]);

    const pendenciasStats = useMemo(() => {
        const ciclosRelevantes = ciclos.filter(isCicloRealmenteAtivo);
        let totalEsperado = 0;
        let totalRealizado = 0;
        const porTurma = {};

        const mapRespostas = {};
        respostas.forEach(r => {
            if (!mapRespostas[r.ciclo_id]) mapRespostas[r.ciclo_id] = {};
            mapRespostas[r.ciclo_id][r.cadete_id] = (mapRespostas[r.ciclo_id][r.cadete_id] || 0) + 1;
        });

        ciclosRelevantes.forEach(ciclo => {
            const turmaNome = ciclo.turma_nome || "Turma Desconhecida";
            const alunosDaTurma = alunos.filter(a => String(a.turma_id) === String(ciclo.turma_id));
            const qtdProfs = ciclo.professores_ids ? ciclo.professores_ids.length : 0;
            
            if (qtdProfs === 0) return;
            if (!porTurma[turmaNome]) porTurma[turmaNome] = { esperado: 0, realizado: 0 };

            alunosDaTurma.forEach(aluno => {
                const feitas = mapRespostas[ciclo.id]?.[aluno.id] || 0;
                totalEsperado += qtdProfs;
                totalRealizado += Math.min(feitas, qtdProfs);
                porTurma[turmaNome].esperado += qtdProfs;
                porTurma[turmaNome].realizado += Math.min(feitas, qtdProfs);
            });
        });

        const calcTaxa = (realizado, esperado) => {
            if (esperado === 0) return ciclosRelevantes.length > 0 ? 100 : 0;
            if (realizado === 0) return 0;
            if (realizado === esperado) return 100;
            const pct = (realizado / esperado) * 100;
            return pct < 1 ? Number(pct.toFixed(1)) : Math.round(pct);
        };

        const taxaGeral = calcTaxa(totalRealizado, totalEsperado);
        
        const turmasArray = Object.keys(porTurma).map(t => ({
            turma: t,
            taxa: calcTaxa(porTurma[t].realizado, porTurma[t].esperado)
        })).sort((a,b) => b.taxa - a.taxa);

        return { taxaGeral, turmas: turmasArray };
    }, [ciclos, alunos, respostas]);

    const totalPendentes = useMemo(() => {
        return Object.values(pendenciasAgrupadas).reduce((acc, pelotoesObj) =>
            acc + Object.values(pelotoesObj).reduce((a, lista) => a + lista.length, 0), 0);
    }, [pendenciasAgrupadas]);

    // --------- RESULTADOS ---------
    const respostasEnriquecidas = useMemo(() => {
        return respostas.map(r => {
            const ciclo = ciclos.find(c => c.id === r.ciclo_id);
            const alunoInfo = mapAlunosGlobais[r.cadete_id] || {};
            
            let notaGeral = r.nota_geral;
            if (!notaGeral) {
                const sum = (Number(r.conhecimento_materia) || 0) +
                            (Number(r.desempenho_professor) || 0) +
                            (Number(r.capacidade_comunicacao) || 0) +
                            (Number(r.motiva_participacao) || 0) +
                            (Number(r.preparacao_aulas) || 0) +
                            (Number(r.postura_sala) || 0) +
                            (Number(r.relacionamento_interpessoal) || 0);
                notaGeral = sum > 0 ? (sum / 7).toFixed(2) : 0;
            }

            return {
                ...r,
                nota_geral: notaGeral,
                curso_nome: ciclo?.curso_nome || 'Sem Curso',
                turma_nome: ciclo?.turma_nome || 'Sem Turma',
                aluno_nome: alunoInfo.nome || 'Desconhecido',
                aluno_re: alunoInfo.matricula || 'N/D',
                aluno_pelotao: alunoInfo.pelotao_nome || 'Sem Pelotão'
            };
        });
    }, [respostas, ciclos, mapAlunosGlobais]);

    const cursosComResultados = useMemo(() => {
        const cursos = new Set(ciclos.filter(c => c.curso_nome).map(c => c.curso_nome));
        return Array.from(cursos).sort();
    }, [ciclos]);

    useEffect(() => {
        if (cursosComResultados.length > 0 && !selectedCursoResult) {
            setSelectedCursoResult(cursosComResultados[0]);
        }
    }, [cursosComResultados, selectedCursoResult]);

    const materiasDoCurso = useMemo(() => {
        if (!selectedCursoResult) return [];
        const materias = new Set();
        professores.forEach(p => {
            p.aulas?.forEach(a => {
                if (a.curso_nome === selectedCursoResult && a.materia_nome) {
                    materias.add(a.materia_nome);
                }
            });
        });
        return Array.from(materias).sort();
    }, [professores, selectedCursoResult]);

    useEffect(() => {
        setSelectedMateriaResult('');
    }, [selectedCursoResult]);

    const turmasDoCurso = useMemo(() => {
        if (!selectedCursoResult) return [];
        const t = new Set();
        ciclos.filter(c => c.curso_nome === selectedCursoResult).forEach(c => {
            if (c.turma_nome) t.add(c.turma_nome);
        });
        return Array.from(t).sort();
    }, [ciclos, selectedCursoResult]);

    const resultadosCalculados = useMemo(() => {
        if (!selectedCursoResult) return [];

        let filtradas = respostasEnriquecidas.filter(r => r.curso_nome === selectedCursoResult);
        if (selectedTurmaResult) {
            filtradas = filtradas.filter(r => r.turma_nome === selectedTurmaResult);
        }

        const mapProfs = {};
        professores.forEach(p => { mapProfs[p.id] = p; });

        if (selectedMateriaResult) {
             filtradas = filtradas.filter(r => {
                 const prof = mapProfs[r.professor_id];
                 return prof?.aulas?.some(a => a.curso_nome === selectedCursoResult && a.materia_nome === selectedMateriaResult);
             });
        }

        const dados = {};
        filtradas.forEach(resp => {
            if (!dados[resp.professor_id]) {
                const prof = mapProfs[resp.professor_id];
                
                let materiasStr = 'N/D';
                if (prof?.aulas) {
                    if (selectedMateriaResult) {
                        materiasStr = selectedMateriaResult; 
                    } else {
                        materiasStr = prof.aulas
                            .filter(a => a.curso_nome === selectedCursoResult)
                            .map(a => a.materia_nome)
                            .join(' / ') || 'N/D';
                    }
                }

                dados[resp.professor_id] = { 
                    id: resp.professor_id,
                    nome: prof?.nome_completo || 'Desconhecido', 
                    posto: prof?.posto || '', 
                    materia: materiasStr,
                    foto: prof?.foto || prof?.fotoUrl || prof?.foto_url || prof?.url_foto || null,
                    somaGeral: 0, 
                    qtdAvaliacoes: 0,
                    avaliacoes: [] 
                };
            }
            if (resp.nota_geral) {
                dados[resp.professor_id].somaGeral += Number(resp.nota_geral);
                dados[resp.professor_id].qtdAvaliacoes += 1;
                dados[resp.professor_id].avaliacoes.push(resp);
            }
        });
        
        let lista = Object.values(dados)
            .map(d => {
                const avaliacoesOrdenadas = d.avaliacoes.sort((a, b) => Number(b.nota_geral) - Number(a.nota_geral));
                return { 
                    ...d, 
                    avaliacoes: avaliacoesOrdenadas,
                    mediaFinal: d.qtdAvaliacoes > 0 ? (d.somaGeral / d.qtdAvaliacoes).toFixed(2) : 0 
                };
            });

        if (filterProfessor) lista = lista.filter(d => d.nome.toLowerCase().includes(filterProfessor.toLowerCase()));

        lista.sort((a, b) => {
            let valA = a[sortConfig.key];
            let valB = b[sortConfig.key];
            
            if (sortConfig.key === 'mediaFinal' || sortConfig.key === 'qtdAvaliacoes') {
                valA = parseFloat(valA);
                valB = parseFloat(valB);
            } else if (sortConfig.key === 'nome') {
                valA = valA.toLowerCase();
                valB = valB.toLowerCase();
            }

            if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
            if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });

        return lista;
    }, [respostasEnriquecidas, professores, selectedCursoResult, selectedTurmaResult, selectedMateriaResult, filterProfessor, sortConfig]);

    const mediaGeral = useMemo(() => {
        if (resultadosCalculados.length === 0) return '0.00';
        return (resultadosCalculados.reduce((acc, r) => acc + parseFloat(r.mediaFinal), 0) / resultadosCalculados.length).toFixed(2);
    }, [resultadosCalculados]);

    const totalAvaliacoesFiltradas = useMemo(() => {
        return resultadosCalculados.reduce((acc, curr) => acc + curr.qtdAvaliacoes, 0);
    }, [resultadosCalculados]);

    const dadosPorTurma = useMemo(() => {
        const map = {};
        if (respostasEnriquecidas.length === 0) return [{ name: 'Sem Dados', value: 1 }];
        
        respostasEnriquecidas.forEach(r => {
            if (r.curso_nome === selectedCursoResult) {
                const turmaNome = r.turma_nome || 'Outras';
                map[turmaNome] = (map[turmaNome] || 0) + 1;
            }
        });

        const arr = Object.entries(map)
            .map(([name, value]) => ({ name, value }))
            .sort((a, b) => b.value - a.value); 
            
        return arr.length > 0 ? arr : [{ name: 'Sem Dados', value: 1 }];
    }, [respostasEnriquecidas, selectedCursoResult]);

    const comentariosFiltrados = useMemo(() => {
        let commentsList = respostasEnriquecidas
            .filter(r => r.curso_nome === selectedCursoResult && (!selectedTurmaResult || r.turma_nome === selectedTurmaResult));
        
        if (selectedMateriaResult) {
            const mapProfs = {};
            professores.forEach(p => { mapProfs[p.id] = p; });
            commentsList = commentsList.filter(r => {
                const prof = mapProfs[r.professor_id];
                return prof?.aulas?.some(a => a.curso_nome === selectedCursoResult && a.materia_nome === selectedMateriaResult);
            });
        }

        return commentsList
            .filter(r => r.comentarios_gerais && r.comentarios_gerais.trim().length > 0)
            .map(r => ({
                id: r.id,
                professor: professores.find(p => p.id === r.professor_id)?.nome_completo || 'Desconhecido',
                comentario: r.comentarios_gerais,
                nota: r.nota_geral,
                data: r.respondido_em ? new Date(r.respondido_em.toDate?.() || r.respondido_em).toLocaleDateString('pt-BR') : 'N/D'
            }))
            .sort((a, b) => a.professor.localeCompare(b.professor));
    }, [respostasEnriquecidas, selectedCursoResult, selectedTurmaResult, selectedMateriaResult, professores]);


    // ==================== USEEFFECTS ====================
    useEffect(() => {
        setLoading(true);
        const unsubCiclos = onSnapshot(collection(db, paths.avaliacoesCiclos), snap => setCiclos(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubTurmas = onSnapshot(collection(db, paths.turmas), snap => setTurmas(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubProfs = onSnapshot(collection(db, paths.professores), snap => setProfessores(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
        
        setLoading(false);
        return () => { unsubCiclos(); unsubTurmas(); unsubProfs(); };
    }, []);

    useEffect(() => {
        if (activeTab === 'ciclos') return;

        const loadRespostas = async () => {
            if (activeTab === 'resultados') {
                const snap = await getDocs(collection(db, paths.avaliacoesRespostas));
                setRespostas(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            }
        };

        if (activeTab === 'resultados') {
            loadRespostas();
        } else if (activeTab === 'pendencias') {
            const unsubRespostas = onSnapshot(collection(db, paths.avaliacoesRespostas), snap => {
                setRespostas(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            });
            return () => unsubRespostas();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab !== 'pendencias' && activeTab !== 'resultados') return;
        const qAlunos = query(collection(db, paths.users), where("nivel", "in", ["cadete", "cadete_academico", "escalante"]));
        const unsubAlunos = onSnapshot(qAlunos, snap => {
            setAlunos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        return () => unsubAlunos();
    }, [activeTab]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.action-menu-container')) setActionMenuOpenId(null);
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    // ==================== HANDLERS ====================
    const handleSort = (key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    const handleCreateCiclo = async (e) => {
        e.preventDefault();
        if (!formCiclo.turma_id || formCiclo.professores_ids.length === 0) return alert("Selecione a turma e pelo menos um professor.");
        setProcessing(true);
        try {
            const turmaNome = turmas.find(t => t.id === formCiclo.turma_id)?.nome;
            await addDoc(collection(db, paths.avaliacoesCiclos), { ...formCiclo, turma_nome: turmaNome, criado_em: serverTimestamp() });
            await logAuditoria(userProfile, "Criou Ciclo de Avaliação", { titulo: formCiclo.titulo, turma: turmaNome });
            setShowModal(false);
            setFormCiclo({ titulo: '', curso_nome: '', turma_id: '', professores_ids: [], ativo: true, data_inicio: '', data_fim: '' });
        } catch (err) { alert("Erro: " + err.message); } finally { setProcessing(false); }
    };

    const handleEditPrazo = async (e) => {
        e.preventDefault();
        setProcessing(true);
        try {
            const cicloAtual = ciclos.find(c => c.id === editCicloData.id);
            const updatePayload = { data_fim: editCicloData.data_fim };
            
            if (!cicloAtual.data_fim_original && cicloAtual.data_fim) {
                updatePayload.data_fim_original = cicloAtual.data_fim;
            }

            await updateDoc(doc(db, paths.avaliacoesCiclos, editCicloData.id), updatePayload);
            await logAuditoria(userProfile, "Prorrogou Ciclo de Avaliação", { titulo: editCicloData.titulo, nova_data: editCicloData.data_fim });
            setShowEditCicloModal(false);
        } catch (err) { alert("Erro ao prorrogar: " + err.message); } finally { setProcessing(false); }
    };

    const handleToggleCiclo = async (ciclo) => {
        const novoStatus = !ciclo.ativo;
        if (novoStatus) {
            const ciclosAtivos = ciclos.filter(c => isCicloRealmenteAtivo(c) && c.id !== ciclo.id);
            const professoresComConflito = [];

            ciclo.professores_ids?.forEach(profId => {
                const conflito = ciclosAtivos.find(c => 
                    c.professores_ids?.includes(profId) && 
                    (!c.curso_nome || !ciclo.curso_nome || c.curso_nome === ciclo.curso_nome)
                );
                if (conflito) {
                    const prof = professores.find(p => p.id === profId);
                    if (prof && !professoresComConflito.includes(prof.nome_completo)) professoresComConflito.push(prof.nome_completo);
                }
            });

            if (professoresComConflito.length > 0) {
                return alert(`Não é possível reabrir este ciclo.\n\nOs seguintes professores já possuem avaliações abertas para este curso:\n- ${professoresComConflito.join('\n- ')}\n\nEncerre os ciclos ativos primeiro.`);
            }
        }
        if (!window.confirm(`Deseja ${novoStatus ? 'REABRIR' : 'ENCERRAR MANUALMENTE'} este ciclo?`)) return;
        await updateDoc(doc(db, paths.avaliacoesCiclos, ciclo.id), { ativo: novoStatus });
    };

    const handleDeleteCiclo = async (ciclo) => {
        if (!window.confirm(`ATENÇÃO: Excluir o ciclo "${ciclo.titulo}"?`)) return;
        setProcessing(true);
        try {
            await deleteDoc(doc(db, paths.avaliacoesCiclos, ciclo.id));
            const q = query(collection(db, paths.avaliacoesRespostas), where("ciclo_id", "==", ciclo.id));
            const snap = await getDocs(q);
            const batch = writeBatch(db);
            snap.docs.forEach(d => batch.delete(d.ref));
            await batch.commit();
            await logAuditoria(userProfile, "Excluiu Ciclo de Avaliação", { titulo: ciclo.titulo });
        } catch (err) { alert("Erro: " + err.message); } finally { setProcessing(false); }
    };

    const toggleActionMenu = (id, e) => {
        e.stopPropagation();
        setActionMenuOpenId(actionMenuOpenId === id ? null : id);
    };

    const handleExportCSV = () => {
        const headers = ['Professor', 'Materia(s)', 'Avaliacoes', 'Media Final'];
        const rows = resultadosCalculados.map(r => [
            `"${r.nome}"`, `"${r.materia}"`, r.qtdAvaliacoes, r.mediaFinal
        ]);

        const csvContent = "\uFEFF" + headers.join(";") + "\n" + rows.map(e => e.join(";")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Resultados_Gerais_${selectedCursoResult}_${new Date().getTime()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    // ========== FUNÇÕES DO DOSSIÊ ==========
    const handleExportTeacherData = (res) => {
        const headers = ['Avaliacao_ID', 'Cadete_Nome', 'Cadete_RE', 'Cadete_Pelotao', 'Nota Geral', 'Conhecimento da Materia', 'Desempenho como Professor', 'Capacidade de Comunicacao', 'Motiva a Participacao', 'Preparacao das Aulas', 'Postura em Sala de Aula', 'Relacionamento Interpessoal', 'Comentarios'];
        const rows = res.avaliacoes.map((av, i) => [
            `#${i+1}`,
            `"Anônimo"`, 
            `"Oculto"`,
            `"${av.aluno_pelotao || ''}"`,
            av.nota_geral || '',
            av.conhecimento_materia || '',
            av.desempenho_professor || '',
            av.capacidade_comunicacao || '',
            av.motiva_participacao || '',
            av.preparacao_aulas || '',
            av.postura_sala || '',
            av.relacionamento_interpessoal || '',
            `"${(av.comentarios_gerais || '').replace(/"/g, '""')}"`
        ]);

        const csvContent = "\uFEFF" + headers.join(";") + "\n" + rows.map(e => e.join(";")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Dossie_Docente_${res.nome.replace(/\s+/g, '_')}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const handlePrintDossie = (res, maiorNota, menorNota, incluirComentarios) => {
        const win = window.open('', '_blank');
        const dataStr = new Date().toLocaleDateString('pt-BR');
        
        const html = `
            <html>
                <head>
                    <title>Dossiê - ${res.nome}</title>
                    <style>
                        body { font-family: 'Courier New', Courier, monospace; padding: 40px; color: #000; font-size: 14px; line-height: 1.5; }
                        .header { display: flex; align-items: flex-start; justify-content: space-between; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 20px; }
                        .header img { height: 90px; }
                        .header-titles { text-align: center; flex: 1; margin-top: 10px; }
                        .header-titles h1 { margin: 0; font-size: 18px; font-weight: normal;}
                        .header-titles h2 { margin: 15px 0 0; font-size: 14px; text-transform: uppercase; font-weight: bold; }
                        .header-right { text-align: right; font-size: 12px; font-style: italic; }
                        .info-block { border-bottom: 2px solid #000; padding-bottom: 15px; margin-bottom: 30px; font-weight: bold; }
                        .stats { display: flex; gap: 20px; margin-bottom: 40px; border-bottom: 1px dashed #000; padding-bottom: 20px;}
                        .stat-box { flex: 1; text-align: center; }
                        .stat-box h3 { margin: 0 0 5px 0; font-size: 24px; color: #000; }
                        .stat-box p { margin: 0; font-size: 12px; text-transform: uppercase; font-weight: bold; }
                        .comments { margin-top: 20px; }
                        .comments h2 { border-bottom: 1px solid #000; padding-bottom: 5px; font-size: 16px; margin-bottom: 20px;}
                        .comment-box { margin-bottom: 20px; padding-left: 15px; border-left: 3px solid #000;}
                        .comment-box strong { font-size: 14px; display: block; margin-bottom: 5px;}
                        .footer { margin-top: 50px; text-align: center; font-size: 10px; border-top: 1px solid #000; padding-top: 20px; font-style: italic;}
                        @media print { body { padding: 0; } }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão" />
                        <div class="header-titles">
                            <h1>ACADEMIA DE POLÍCIA MILITAR DO BARRO BRANCO</h1>
                            <h2>DOSSIÊ GERAL DE AVALIAÇÃO DE DOCENTE</h2>
                        </div>
                        <div class="header-right">
                            <p>Sistema Integrado Acadêmico</p>
                            <p>${dataStr}</p>
                        </div>
                    </div>

                    <div class="info-block">
                        <div style="margin-bottom: 5px;">Professor: ${res.posto} - ${res.nome}</div>
                        <div>Matéria(s): ${res.materia}</div>
                    </div>
                    
                    <div class="stats">
                        <div class="stat-box"><h3>${res.qtdAvaliacoes}</h3><p>Avaliações Recebidas</p></div>
                        <div class="stat-box"><h3>${res.mediaFinal}</h3><p>Média do Ciclo</p></div>
                        <div class="stat-box"><h3>${maiorNota}</h3><p>Maior Nota</p></div>
                        <div class="stat-box"><h3>${menorNota}</h3><p>Menor Nota</p></div>
                    </div>

                    ${incluirComentarios ? `
                        <div class="comments">
                            <h2>Comentários e Sugestões Registrados</h2>
                            ${res.avaliacoes.filter(a => a.comentarios_gerais).map((a, index) => `
                                <div class="comment-box">
                                    <strong>Avaliação #${index + 1} (Nota: ${a.nota_geral})</strong>
                                    <em>"${a.comentarios_gerais}"</em>
                                </div>
                            `).join('') || '<p style="font-style: italic;">Nenhum comentário por escrito registrado neste ciclo.</p>'}
                        </div>
                    ` : ''}
                    
                    <div class="footer">Documento gerado automaticamente pelo Sistema Integrado Acadêmico</div>
                    <script>window.onload = function() { window.print(); }</script>
                </body>
            </html>
        `;
        win.document.write(html); win.document.close();
        setShowDossieModal(false); 
    };

    const handlePrintIndividualReport = (res, av, showRealName = false) => {
        const win = window.open('', '_blank');
        const dataStr = av.respondido_em ? new Date(av.respondido_em.toDate?.() || av.respondido_em).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR');
        
        const alunoPelotaoStr = av.aluno_pelotao || 'N/D';
        const avaliadorStr = showRealName ? `Cadete ${av.aluno_nome} (RE: ${av.aluno_re})` : 'Cadete (Anônimo)';

        const html = `
            <html>
                <head>
                    <title>Relatório Individual - ${res.nome}</title>
                    <style>
                        body { font-family: 'Courier New', Courier, monospace; padding: 40px; color: #000; font-size: 14px; line-height: 1.5; }
                        .header { display: flex; align-items: flex-start; justify-content: space-between; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 20px; }
                        .header img { height: 90px; }
                        .header-titles { text-align: center; flex: 1; margin-top: 10px; }
                        .header-titles h1 { margin: 0; font-size: 18px; font-weight: normal;}
                        .header-titles h2 { margin: 15px 0 0; font-size: 14px; text-transform: uppercase; font-weight: bold; }
                        .header-right { text-align: right; font-size: 12px; font-style: italic; }
                        .info-block { border-bottom: 2px solid #000; padding-bottom: 15px; margin-bottom: 30px; font-weight: bold; }
                        .question { margin-bottom: 20px; }
                        .question-text { text-transform: uppercase; margin-bottom: 5px; }
                        .note { font-weight: bold; margin-bottom: 15px; }
                        @media print { body { padding: 0; } }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão" />
                        <div class="header-titles">
                            <h1>ACADEMIA DE POLÍCIA MILITAR DO BARRO BRANCO</h1>
                            <h2>RELATÓRIO INDIVIDUAL DE AVALIAÇÃO DE DOCENTE</h2>
                        </div>
                        <div class="header-right">
                            <p>Sistema Integrado Acadêmico</p>
                            <p>${dataStr}</p>
                        </div>
                    </div>
                    <div class="info-block">
                        <div style="margin-bottom: 5px;">Turma/Pelotão: ${alunoPelotaoStr}</div>
                        <div style="margin-bottom: 5px;">Avaliador: ${avaliadorStr}</div>
                        <div style="margin-top: 15px; border-top: 1px solid #000; padding-top: 10px;">Professor: ${res.posto} - ${res.nome}</div>
                        <div>Matéria: ${res.materia}</div>
                    </div>
                    
                    <div class="question">
                        <div class="question-text">1. CONHECIMENTO DA MATÉRIA. (Competência na solução e esclarecimento de dúvidas, deixando evidente que conhece a matéria)</div>
                        <div class="note">Nota: ${Number(av.conhecimento_materia || 0).toFixed(2)}</div>
                    </div>
                    <div class="question">
                        <div class="question-text">2. DESEMPENHO COMO PROFESSOR. (Usa as técnicas de ensino e mantém a atenção, bem como o interesse dos alunos)</div>
                        <div class="note">Nota: ${Number(av.desempenho_professor || 0).toFixed(2)}</div>
                    </div>
                    <div class="question">
                        <div class="question-text">3. CAPACIDADE DE COMUNICAÇÃO E TRANSMISSÃO DA MATÉRIA. (Possui boa dicção e usa de uma linguagem adequada ao nível da turma)</div>
                        <div class="note">Nota: ${Number(av.capacidade_comunicacao || 0).toFixed(2)}</div>
                    </div>
                    <div class="question">
                        <div class="question-text">4. MOTIVA A PARTICIPAÇÃO DO ALUNO. (Mantém o interesse dos alunos e relaciona os assuntos às suas aplicações práticas na Instituição)</div>
                        <div class="note">Nota: ${Number(av.motiva_participacao || 0).toFixed(2)}</div>
                    </div>
                    <div class="question">
                        <div class="question-text">5. PREPARAÇÃO DAS AULAS. (Respeita os horários e o planejamento das aulas)</div>
                        <div class="note">Nota: ${Number(av.preparacao_aulas || 0).toFixed(2)}</div>
                    </div>
                    <div class="question">
                        <div class="question-text">6. POSTURA EM SALA DE AULA. (Correção de atitudes, prima pelo bom exemplo)</div>
                        <div class="note">Nota: ${Number(av.postura_sala || 0).toFixed(2)}</div>
                    </div>
                    <div class="question">
                        <div class="question-text">7. RELACIONAMENTO INTERPESSOAL COM OS ALUNOS. (Respeito aos alunos, à liberdade de expressão e incentivo à participação)</div>
                        <div class="note">Nota: ${Number(av.relacionamento_interpessoal || 0).toFixed(2)}</div>
                    </div>

                    <div style="margin-top: 30px; font-size: 16px; font-weight: bold;">
                        Média Final: ${Number(av.nota_geral || 0).toFixed(2)}
                    </div>

                    ${av.comentarios_gerais ? `
                    <div style="margin-top: 30px; border-top: 1px dashed #000; padding-top: 20px;">
                        <div class="question-text" style="font-weight: bold;">COMENTÁRIOS E/OU SUGESTÕES:</div>
                        <div style="margin-top: 10px; font-style: italic;">"${av.comentarios_gerais}"</div>
                    </div>` : ''}
                    
                    <script>window.onload = function() { window.print(); }</script>
                </body>
            </html>
        `;
        win.document.write(html); win.document.close();
    };

    const handlePrintPendencias = (turma, pelotoesObj) => {
        const win = window.open('', '_blank');
        
        const pelotoesHTML = Object.keys(pelotoesObj).sort().map(pelotao => {
            if(pelotoesObj[pelotao].length === 0) return '';
            return `
            <div style="margin-top: 30px; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 2px solid #e5e7eb;">
                <h3 style="margin: 0; color: #374151; font-size: 16px;">Pelotão: ${pelotao}</h3>
            </div>
            <table>
                <thead>
                    <tr><th style="width: 15%">RE</th><th style="width: 60%">Cadete</th><th style="width: 25%">Pendentes</th></tr>
                </thead>
                <tbody>
                    ${pelotoesObj[pelotao].map(a => `
                        <tr>
                            <td style="font-family: monospace;">${a.re}</td>
                            <td>${a.nome}</td>
                            <td><strong>${a.faltam}</strong> de ${a.total}</td>
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `}).join('');

        const html = `
            <html>
                <head>
                    <title>Relatório de Pendências - ${turma}</title>
                    <style>
                        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #333; }
                        .header { display: flex; align-items: center; border-bottom: 2px solid #1e3a8a; padding-bottom: 20px; margin-bottom: 30px; }
                        .header img { height: 60px; margin-right: 20px; }
                        .header-text h1 { margin: 0; color: #1e3a8a; font-size: 24px; }
                        .header-text p { margin: 5px 0 0; color: #666; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                        th, td { border: 1px solid #e5e7eb; padding: 10px; text-align: left; font-size: 14px;}
                        th { background-color: #f3f4f6; color: #374151; font-weight: bold; text-transform: uppercase; font-size: 12px; }
                        tr:nth-child(even) { background-color: #f9fafb; }
                        .footer { margin-top: 40px; text-align: center; font-size: 10px; color: #9ca3af; }
                        @media print { body { padding: 0; } }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão" />
                        <div class="header-text">
                            <h1>Relatório Completo de Pendências</h1>
                            <p><strong>Turma:</strong> ${turma}</p>
                            <p><strong>Data de Emissão:</strong> ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}</p>
                        </div>
                    </div>
                    ${pelotoesHTML}
                    <div class="footer">Gerado pelo Sistema Integrado Acadêmico - Academia do Barro Branco</div>
                    <script>window.onload = function() { window.print(); }</script>
                </body>
            </html>
        `;
        win.document.write(html); win.document.close();
    };

    const toggleTeacherDrawer = (id) => {
        setExpandedTeacherId(expandedTeacherId === id ? null : id);
        setExpandedAssessmentId(null); 
    };

    const toggleAssessmentAccordion = (id, e) => {
        e.stopPropagation(); 
        setExpandedAssessmentId(expandedAssessmentId === id ? null : id);
    };

    const getPageTitle = () => {
        if(activeTab === 'ciclos') return 'Gestão de Ciclos';
        if(activeTab === 'resultados') return 'Dashboard de Resultados';
        return 'Controle Acadêmico';
    };

    if (loading) return <LoadingSpinner />;

    return (
        <div className="flex h-full w-full bg-slate-50 font-sans overflow-hidden">
            
            {/* OVERLAY MOBILE */}
            {isSidebarOpen && (
                <div className="fixed inset-0 bg-slate-900/50 z-40 md:hidden" onClick={() => setIsSidebarOpen(false)} />
            )}

            {/* ====================== SIDEBAR ESQUERDA ====================== */}
            <aside className={`fixed md:static inset-y-0 left-0 w-72 bg-white border-r border-slate-200 flex flex-col z-50 shrink-0 transform transition-transform duration-300 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`}>
                <div className="p-8 flex flex-col items-center border-b border-transparent mt-4 relative">
                    <button onClick={() => setIsSidebarOpen(false)} className="md:hidden absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600">
                        <XIcon className="w-6 h-6"/>
                    </button>
                    <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão APMBB" className="w-16 h-16 object-contain mb-5" onError={(e) => e.target.style.display = 'none'} />
                    <h2 className="text-xl font-bold text-slate-800">Avaliação Docente</h2>
                    <span className="text-[10px] font-bold text-slate-400 tracking-widest mt-1.5 uppercase">Portal Administrativo</span>
                </div>
                
                <nav className="flex-1 px-4 space-y-2 mt-8">
                    <button 
                        onClick={() => { setActiveTab('ciclos'); setIsSidebarOpen(false); }}
                        className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl font-semibold transition-all ${activeTab === 'ciclos' ? 'bg-indigo-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'}`}
                    >
                        <DashboardIcon /> Ciclos de Avaliação
                    </button>
                    <button 
                        onClick={() => { setActiveTab('resultados'); setIsSidebarOpen(false); }}
                        className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl font-semibold transition-all ${activeTab === 'resultados' ? 'bg-indigo-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'}`}
                    >
                        <ChartBarIcon /> Resultados Consolidados
                    </button>
                    <button 
                        onClick={() => { setActiveTab('pendencias'); setIsSidebarOpen(false); }}
                        className={`w-full flex items-center justify-between px-4 py-3.5 rounded-xl font-semibold transition-all ${activeTab === 'pendencias' ? 'bg-indigo-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'}`}
                    >
                        <div className="flex items-center gap-3"><UserGroupIcon className="w-5 h-5" /> Controle de Pendências</div>
                        {totalPendentes > 0 && (
                            <span className={`w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-bold ${activeTab === 'pendencias' ? 'bg-white text-indigo-600' : 'bg-red-500 text-white'}`}>
                                {totalPendentes}
                            </span>
                        )}
                    </button>
                </nav>
            </aside>

            {/* ====================== CONTEÚDO PRINCIPAL ====================== */}
            <main className="flex-1 flex flex-col h-full overflow-hidden bg-[#FAFAFA] relative">
                
                {/* TOPO DA PÁGINA */}
                <header className="bg-white border-b border-slate-200 h-24 flex items-center justify-between px-4 md:px-8 shrink-0">
                    <div className="flex items-center gap-4">
                        <button className="md:hidden p-2 text-slate-500 hover:bg-slate-100 rounded-lg" onClick={() => setIsSidebarOpen(true)}>
                            <MenuIcon />
                        </button>
                        <h1 className="text-xl md:text-2xl font-bold text-slate-800 hidden sm:block">{getPageTitle()}</h1>
                        <div className="flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-slate-50 border border-slate-100 rounded-lg text-[10px] md:text-xs font-bold text-slate-500 tracking-wide">
                            <CalendarIcon /> TURNO ACADÊMICO 2026.1
                        </div>
                    </div>
                    <div className="flex items-center gap-2 md:gap-6">
                        <button className="hidden md:block text-slate-400 hover:text-slate-600"><BellIcon /></button>
                        <button className="hidden md:block text-slate-400 hover:text-slate-600"><GearIcon /></button>
                        <div className="hidden md:block h-8 w-px bg-slate-200 mx-2"></div>
                        <button onClick={() => setShowModal(true)} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 md:px-6 md:py-2.5 rounded-xl text-sm font-bold shadow-md transition-colors flex items-center gap-2">
                            <PlusIcon className="w-4 h-4" /> <span className="hidden sm:inline">Novo Ciclo</span>
                        </button>
                    </div>
                </header>

                <div className="flex-1 overflow-y-auto p-4 md:p-8 relative z-0">
                    
                    {/* ================= ABA 1: GESTÃO DE CICLOS ================= */}
                    {activeTab === 'ciclos' && (
                        <div className="animate-fade-in grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {ciclos.map(c => {
                                const status = getStatusCiclo(c);
                                const StatusIcon = status.Icon;
                                return (
                                <div key={c.id} className="bg-white rounded-[24px] border border-slate-200/60 shadow-sm p-6 flex flex-col relative min-h-[260px]">
                                    <div className="flex justify-between items-start mb-6">
                                        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center text-white ${status.dot} shadow-sm`}>
                                            <StatusIcon className="w-6 h-6" />
                                        </div>
                                        <div className="relative action-menu-container">
                                            <button onClick={(e) => toggleActionMenu(c.id, e)} className="text-slate-300 hover:text-slate-500 p-1">
                                                <DotsIcon />
                                            </button>
                                            {actionMenuOpenId === c.id && (
                                                <div className="absolute right-0 top-8 w-56 bg-white rounded-xl shadow-xl border border-gray-200 z-50 overflow-hidden">
                                                    <button onClick={() => { handleToggleCiclo(c); setActionMenuOpenId(null); }} className="w-full text-left px-4 py-3 hover:bg-slate-50 flex items-center gap-2 text-sm font-medium text-slate-700">
                                                        {c.ativo ? <LockClosedIcon /> : <RefreshIcon className="w-4 h-4" />} {c.ativo ? 'Encerrar Manual' : 'Reabrir Manual'}
                                                    </button>
                                                    <button onClick={() => { 
                                                        setEditCicloData({ id: c.id, titulo: c.titulo, data_fim: c.data_fim }); 
                                                        setShowEditCicloModal(true); 
                                                        setActionMenuOpenId(null); 
                                                    }} className="w-full text-left px-4 py-3 hover:bg-slate-50 flex items-center gap-2 text-sm font-medium text-slate-700 border-t border-slate-100">
                                                        <CalendarIcon /> Prorrogar Prazo
                                                    </button>
                                                    <button onClick={() => { handleDeleteCiclo(c); setActionMenuOpenId(null); }} className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 flex items-center gap-2 border-t border-slate-100 text-sm font-medium">
                                                        <TrashIcon /> Excluir Ciclo
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <div className="flex-1">
                                        <h3 className="text-xl font-bold text-slate-800 mb-2">{c.titulo}</h3>
                                        <div className="flex items-center gap-2 text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-6">
                                            <span className="bg-slate-100 px-2 py-1 rounded-md">{c.turma_nome || 'N/D'}</span>
                                            <span>•</span>
                                            <span>{c.curso_nome || 'GERAL'}</span>
                                        </div>

                                        <div className="space-y-3">
                                            <div className="flex justify-between items-center text-sm">
                                                <span className="text-slate-400 font-semibold flex items-center gap-2"><UserGroupIcon className="w-4 h-4"/> PROFESSORES</span>
                                                <span className="font-bold text-slate-700">{c.professores_ids?.length || 0}</span>
                                            </div>
                                            
                                            <div className="flex justify-between items-center text-sm">
                                                <span className="text-slate-400 font-semibold flex items-center gap-2"><CalendarIcon /> VIGÊNCIA</span>
                                                <span className="font-bold text-slate-700">
                                                    {c.data_inicio ? new Date(c.data_inicio + 'T12:00:00').toLocaleDateString('pt-BR') : '--'} - {c.data_fim_original ? new Date(c.data_fim_original + 'T12:00:00').toLocaleDateString('pt-BR') : (c.data_fim ? new Date(c.data_fim + 'T12:00:00').toLocaleDateString('pt-BR') : '--')}
                                                </span>
                                            </div>
                                            
                                            {/* PRORROGAÇÃO INDICADOR */}
                                            {c.data_fim_original && c.data_fim !== c.data_fim_original && (
                                                <div className="flex justify-between items-center text-sm bg-orange-50 px-3 py-2 rounded-lg border border-orange-100 mt-2">
                                                    <span className="text-orange-600 font-bold flex items-center gap-2 text-[10px] uppercase tracking-wider"><CalendarIcon /> Prorrogado até</span>
                                                    <span className="font-bold text-orange-600">{new Date(c.data_fim + 'T12:00:00').toLocaleDateString('pt-BR')}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mt-8 flex justify-between items-center">
                                        <span className={`px-3 py-1.5 rounded-lg text-[10px] font-bold tracking-wider text-white ${status.dot}`}>
                                            {status.text}
                                        </span>
                                    </div>
                                </div>
                            )})}

                            <div 
                                onClick={() => setShowModal(true)}
                                className="rounded-[24px] border-2 border-dashed border-slate-200 bg-transparent flex flex-col items-center justify-center min-h-[260px] cursor-pointer hover:bg-slate-50 hover:border-slate-300 transition-all group"
                            >
                                <div className="w-10 h-10 rounded-full flex items-center justify-center text-slate-400 mb-2 group-hover:text-indigo-500">
                                    <PlusIcon className="w-6 h-6" />
                                </div>
                                <span className="text-xs font-bold text-slate-400 tracking-wider group-hover:text-indigo-500 uppercase">NOVO CICLO</span>
                            </div>
                        </div>
                    )}

                    {/* ================= ABA 2: RESULTADOS CONSOLIDADOS ================= */}
                    {activeTab === 'resultados' && (
                        <div className="animate-fade-in space-y-8">
                            
                            {/* Cards Superiores */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
                                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex items-center justify-between">
                                    <div>
                                        <p className="text-xs font-bold text-slate-400 tracking-wider mb-2">PROFESSORES</p>
                                        <h3 className="text-3xl font-bold text-slate-800">{resultadosCalculados.length}</h3>
                                    </div>
                                    <div className="w-12 h-12 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400"><UserGroupIcon /></div>
                                </div>
                                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex items-center justify-between">
                                    <div>
                                        <p className="text-xs font-bold text-slate-400 tracking-wider mb-2">MÉDIA GERAL</p>
                                        <div className="flex items-end gap-2">
                                            <h3 className="text-3xl font-bold text-slate-800">{mediaGeral}</h3>
                                        </div>
                                    </div>
                                    <div className="w-12 h-12 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400"><DashboardIcon /></div>
                                </div>
                                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex items-center justify-between">
                                    <div>
                                        <p className="text-xs font-bold text-slate-400 tracking-wider mb-2">AVALIAÇÕES</p>
                                        <h3 className="text-3xl font-bold text-slate-800">{totalAvaliacoesFiltradas}</h3>
                                    </div>
                                    <div className="w-12 h-12 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400"><DocumentIcon /></div>
                                </div>
                                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex items-center justify-between">
                                    <div>
                                        <p className="text-xs font-bold text-slate-400 tracking-wider mb-2">CICLOS ATIVOS</p>
                                        <h3 className="text-3xl font-bold text-slate-800">{ciclos.filter(isCicloRealmenteAtivo).length}</h3>
                                    </div>
                                    <div className="w-12 h-12 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400"><PlusIcon /></div>
                                </div>
                            </div>

                            {/* Área da Tabela */}
                            <div>
                                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                                    {/* SEÇÃO DE FILTROS (CURSOS E MATÉRIAS) */}
                                    <div className="flex flex-wrap items-center gap-2">
                                        <div className="flex flex-wrap bg-white rounded-full p-1 border border-slate-200">
                                            {cursosComResultados.map(curso => (
                                                <button
                                                    key={curso}
                                                    onClick={() => setSelectedCursoResult(curso)}
                                                    className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${selectedCursoResult === curso ? 'bg-indigo-50 text-indigo-700' : 'text-slate-400 hover:text-slate-600'}`}
                                                >
                                                    {curso}
                                                </button>
                                            ))}
                                        </div>
                                        
                                        {materiasDoCurso.length > 0 && (
                                            <select 
                                                value={selectedMateriaResult} 
                                                onChange={e => setSelectedMateriaResult(e.target.value)}
                                                className="bg-white border border-slate-200 text-slate-500 hover:text-slate-700 text-sm rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 font-bold transition-all cursor-pointer shadow-sm"
                                            >
                                                <option value="">Todas as Matérias</option>
                                                {materiasDoCurso.map(m => <option key={m} value={m}>{m}</option>)}
                                            </select>
                                        )}
                                    </div>

                                    <div className="flex flex-wrap items-center gap-4">
                                        <button 
                                            onClick={() => setShowCommentsModal(true)}
                                            className="flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-700 rounded-lg text-sm font-bold hover:bg-indigo-100 transition-colors"
                                        >
                                            <ChatIcon /> Ler Comentários ({comentariosFiltrados.length})
                                        </button>
                                        <div className="relative">
                                            <SearchIcon className="w-4 h-4 text-slate-300 absolute left-3 top-1/2 transform -translate-y-1/2" />
                                            <input 
                                                type="text" placeholder="Pesquisar docente..." 
                                                value={filterProfessor} onChange={e => setFilterProfessor(e.target.value)}
                                                className="pl-9 pr-4 py-2 border-none bg-transparent text-sm focus:outline-none w-48 text-slate-600"
                                            />
                                        </div>
                                        <button onClick={handleExportCSV} className="flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-slate-700"><DownloadIcon className="w-4 h-4"/> Exportar Geral</button>
                                    </div>
                                </div>

                                <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full">
                                            <thead className="bg-slate-50/50">
                                                <tr>
                                                    <th className="px-8 py-5 text-left text-[11px] font-bold text-slate-400 tracking-wider uppercase cursor-pointer" onClick={() => handleSort('nome')}>
                                                        Professor {sortConfig.key === 'nome' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                    <th className="px-8 py-5 text-left text-[11px] font-bold text-slate-400 tracking-wider uppercase">Matéria</th>
                                                    <th className="px-8 py-5 text-center text-[11px] font-bold text-slate-400 tracking-wider uppercase cursor-pointer" onClick={() => handleSort('qtdAvaliacoes')}>
                                                        Avaliações {sortConfig.key === 'qtdAvaliacoes' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                    <th className="px-8 py-5 text-center text-[11px] font-bold text-slate-400 tracking-wider uppercase cursor-pointer" onClick={() => handleSort('mediaFinal')}>
                                                        Média do Ciclo {sortConfig.key === 'mediaFinal' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-slate-50">
                                                {resultadosCalculados.map((res) => (
                                                    <tr 
                                                        key={res.id} 
                                                        onClick={() => toggleTeacherDrawer(res.id)}
                                                        className="hover:bg-slate-50/50 transition-colors cursor-pointer group"
                                                    >
                                                        <td className="px-8 py-4">
                                                            <div className="flex items-center gap-4">
                                                                {res.foto ? (
                                                                    <img src={res.foto} alt={res.nome} className="w-12 h-12 rounded-full object-cover bg-slate-100 border border-slate-200" />
                                                                ) : (
                                                                    <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center border border-slate-200"><UserGroupIcon className="text-slate-400" /></div>
                                                                )}
                                                                <div>
                                                                    <div className="font-bold text-slate-800 text-sm group-hover:text-indigo-600 transition-colors">{res.nome}</div>
                                                                    <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{res.posto}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-8 py-4 text-sm font-semibold text-slate-500">{res.materia}</td>
                                                        <td className="px-8 py-4 text-center text-sm font-bold text-slate-400">{res.qtdAvaliacoes}</td>
                                                        <td className="px-8 py-4 text-center">
                                                            <span className="inline-block px-4 py-1.5 border border-slate-200 rounded-lg text-sm font-bold text-slate-700 bg-white">
                                                                {res.mediaFinal}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {resultadosCalculados.length === 0 && (
                                                    <tr><td colSpan={4} className="text-center py-12 text-slate-500 font-medium">Nenhum resultado encontrado.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ================= ABA 3: CONTROLE DE PENDÊNCIAS ================= */}
                    {activeTab === 'pendencias' && (
                        <div className="animate-fade-in flex flex-col gap-6">
                            
                            {totalPendentes > 0 && (
                                <div className="bg-red-50 border border-red-100 rounded-2xl p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center border border-red-100 shadow-sm shrink-0">
                                            <AlertCircleIcon className="text-red-500" />
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-bold text-red-700">Cadetes com Avaliações Atrasadas</h3>
                                            <p className="text-sm font-medium text-red-500">Foram identificadas inconsistências em {totalPendentes} registros ativos.</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="flex flex-col lg:flex-row gap-6 items-start">
                                {/* Lista de Pendências */}
                                <div className="flex-1 w-full space-y-6">
                                    {Object.entries(pendenciasAgrupadas).map(([turma, pelotoesObj]) => {
                                        const pelotoesKeys = Object.keys(pelotoesObj).sort();
                                        
                                        // Turma-specific filter
                                        const currentTurmaTab = selectedTurmaPendencia || Object.keys(pendenciasAgrupadas)[0];
                                        if (turma !== currentTurmaTab) return null;

                                        const currentFilter = selectedPelotoes[turma] || 'Todos';
                                        let listaAtual = [];
                                        
                                        if (currentFilter === 'Todos') {
                                            Object.values(pelotoesObj).forEach(lista => listaAtual.push(...lista));
                                            listaAtual.sort((a,b) => a.nome.localeCompare(b.nome));
                                        } else {
                                            listaAtual = pelotoesObj[currentFilter] || [];
                                        }

                                        return (
                                        <div key={turma} className="bg-white rounded-[24px] border border-slate-200/60 shadow-sm p-4 md:p-8">
                                            
                                            {/* Abas Superiores de Turma Estilo Imagem */}
                                            <div className="flex overflow-x-auto gap-1 mb-8 border-b border-slate-200">
                                                {Object.keys(pendenciasAgrupadas).map(t => (
                                                    <button 
                                                        key={t}
                                                        onClick={() => setSelectedTurmaPendencia(t)}
                                                        className={`px-5 py-3 text-sm font-bold border-b-[3px] transition-all whitespace-nowrap ${currentTurmaTab === t ? 'border-emerald-500 text-emerald-600 bg-emerald-50/50' : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'}`}
                                                    >
                                                        {t}
                                                    </button>
                                                ))}
                                                <button onClick={() => handlePrintPendencias(turma, pelotoesObj)} className="ml-auto hidden md:flex items-center gap-2 text-xs font-bold text-indigo-600 uppercase tracking-wider hover:text-indigo-800 transition-colors bg-indigo-50 px-4 py-2 rounded-lg mb-2">
                                                    <PrinterIcon className="w-4 h-4"/> Relatório PDF Completo
                                                </button>
                                            </div>
                                            
                                            <div className="md:hidden mb-4">
                                                <button onClick={() => handlePrintPendencias(turma, pelotoesObj)} className="w-full flex justify-center items-center gap-2 text-xs font-bold text-indigo-600 uppercase tracking-wider hover:text-indigo-800 transition-colors bg-indigo-50 px-4 py-3 rounded-lg">
                                                    <PrinterIcon className="w-4 h-4"/> Relatório PDF Completo
                                                </button>
                                            </div>

                                            {/* Filtro de Pelotão Compacto */}
                                            <div className="flex flex-wrap items-center gap-3 mb-6 bg-slate-50 p-3 rounded-xl border border-slate-100">
                                                <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Filtrar Pelotão:</span>
                                                <select 
                                                    value={currentFilter} 
                                                    onChange={e => setSelectedPelotoes(prev => ({...prev, [turma]: e.target.value}))}
                                                    className="bg-white border border-slate-200 text-slate-700 text-sm rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 font-medium"
                                                >
                                                    <option value="Todos">Todos os Pelotões</option>
                                                    {pelotoesKeys.map(p => <option key={p} value={p}>{p}</option>)}
                                                </select>
                                                
                                                <span className="ml-auto text-xs font-bold bg-indigo-100 text-indigo-800 px-3 py-1 rounded-lg">
                                                    {listaAtual.length} Pendentes
                                                </span>
                                            </div>

                                            <div className="space-y-2">
                                                {listaAtual.map((aluno, i) => (
                                                    <div key={aluno.id || i} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-100 group gap-4">
                                                        <div className="flex items-center gap-4">
                                                            <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center text-slate-500 font-bold uppercase shrink-0">
                                                                {aluno.nome.charAt(0)}
                                                            </div>
                                                            <div>
                                                                <h5 className="font-bold text-slate-800 text-sm">Cadete {aluno.nome}</h5>
                                                                <p className="text-[10px] font-bold text-slate-400 tracking-wider uppercase">{aluno.re} • {aluno.pelotao}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-6 w-full sm:w-auto justify-between sm:justify-end">
                                                            <div className="text-left sm:text-right">
                                                                <p className="text-xs font-bold text-red-500 mb-0.5">Atraso Crítico</p>
                                                                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Faltam {aluno.faltam}/{aluno.total} Avaliações</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {listaAtual.length === 0 && <p className="text-center text-slate-400 text-sm py-4">Nenhum cadete pendente neste filtro.</p>}
                                            </div>
                                        </div>
                                    )})}
                                    
                                    {Object.keys(pendenciasAgrupadas).length === 0 && (
                                        <div className="bg-white rounded-[24px] border border-slate-200/60 shadow-sm p-12 text-center">
                                            <div className="flex justify-center mb-4">
                                                <CheckCircleOutlineIcon className="text-emerald-400 w-16 h-16" />
                                            </div>
                                            <h4 className="text-lg font-bold text-emerald-600 mb-2">Tudo em dia!</h4>
                                            <p className="text-slate-500 font-medium">Não há cadetes com avaliações pendentes nos ciclos abertos.</p>
                                        </div>
                                    )}
                                </div>

                                {/* Cards Laterais (Taxa de Conclusão) */}
                                <div className="w-full lg:w-80 flex flex-col gap-6 shrink-0">
                                    <div className="bg-[#4F46E5] text-white rounded-[24px] p-8 shadow-lg">
                                        <div className="w-12 h-12 border-4 border-indigo-400 border-t-white rounded-full mb-6"></div>
                                        <h2 className="text-4xl font-bold mb-2">
                                            {pendenciasStats.taxaGeral}%
                                        </h2>
                                        <p className="text-xs font-bold text-indigo-200 tracking-wider uppercase">Taxa de Conclusão Geral</p>
                                        <div className="w-full bg-indigo-500 rounded-full h-1 mt-6 overflow-hidden">
                                            <div className="bg-white h-1 rounded-full transition-all duration-700" style={{ width: `${pendenciasStats.taxaGeral}%` }}></div>
                                        </div>
                                    </div>

                                    <div className="bg-white rounded-[24px] border border-slate-200/60 shadow-sm p-8">
                                        <h4 className="text-xs font-bold text-slate-800 tracking-wider uppercase mb-6">Performance por Turma</h4>
                                        <div className="space-y-6 mb-8">
                                            {pendenciasStats.turmas.map((t, i) => (
                                                <div key={t.turma}>
                                                    <div className="flex justify-between text-xs font-bold mb-2">
                                                        <span className="text-slate-500 uppercase">{t.turma}</span>
                                                        <span className="text-slate-800">{t.taxa}%</span>
                                                    </div>
                                                    <div className="w-full bg-slate-100 rounded-full h-1.5 overflow-hidden">
                                                        <div className={`h-1.5 rounded-full transition-all duration-700 ${i === 0 ? 'bg-indigo-500' : 'bg-emerald-400'}`} style={{ width: `${t.taxa}%` }}></div>
                                                    </div>
                                                </div>
                                            ))}
                                            {pendenciasStats.turmas.length === 0 && <p className="text-xs text-slate-400 font-medium">Nenhuma turma com ciclos ativos.</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* ====================== DRAWER LATERAL (Detalhes do Professor / Dossiê) ====================== */}
                {expandedTeacherId && (() => {
                    const res = resultadosCalculados.find(r => r.id === expandedTeacherId);
                    if (!res) return null;
                    
                    // Cálculos de Maior e Menor nota para este professor
                    const notas = res.avaliacoes.map(a => Number(a.nota_geral)).filter(n => !isNaN(n) && n > 0);
                    const maiorNota = notas.length > 0 ? Math.max(...notas).toFixed(2) : '--';
                    const menorNota = notas.length > 0 ? Math.min(...notas).toFixed(2) : '--';

                    return (
                        <div className="fixed inset-0 z-50 overflow-hidden flex justify-end">
                            <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity animate-fade-in" onClick={() => toggleTeacherDrawer(null)} />
                            <div className="w-full max-w-2xl bg-slate-50 shadow-2xl h-full overflow-y-auto transform transition-transform duration-300 ease-in-out border-l border-slate-200 relative z-10 animate-slide-in-right">
                                
                                <div className="bg-white px-4 md:px-8 py-6 border-b border-slate-200 sticky top-0 z-10 flex justify-between items-start shadow-sm">
                                    <div className="flex gap-4 items-center">
                                        {res.foto ? (
                                            <img src={res.foto} alt={res.nome} className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover border border-slate-200 shadow-sm cursor-pointer" onClick={() => setExpandedImage(res.foto)} />
                                        ) : (
                                            <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-indigo-50 flex items-center justify-center border border-indigo-100 shadow-sm">
                                                <UserGroupIcon className="w-6 h-6 text-indigo-500" />
                                            </div>
                                        )}
                                        <div>
                                            <h2 className="text-lg md:text-xl font-bold text-slate-800 leading-tight">{res.nome}</h2>
                                            <p className="text-[10px] font-bold text-slate-400 mt-1 uppercase tracking-wider">{res.posto} • {res.materia}</p>
                                        </div>
                                    </div>
                                    <button onClick={() => toggleTeacherDrawer(null)} className="p-2 bg-slate-100 hover:bg-slate-200 rounded-full text-slate-500 transition-colors">
                                        <XIcon />
                                    </button>
                                </div>

                                <div className="p-4 md:p-8">
                                    {/* Estatísticas */}
                                    <div className="grid grid-cols-2 gap-3 md:gap-4 mb-6">
                                        <div className="bg-white p-4 md:p-6 rounded-[20px] border border-slate-200/60 shadow-sm flex flex-col justify-between">
                                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Avaliações Recebidas</span>
                                            <span className="text-2xl md:text-3xl font-bold text-slate-800">{res.qtdAvaliacoes}</span>
                                        </div>
                                        <div className="bg-white p-4 md:p-6 rounded-[20px] border border-slate-200/60 shadow-sm flex flex-col justify-between">
                                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Média Final</span>
                                            <span className={`text-2xl md:text-3xl font-bold ${parseFloat(res.mediaFinal) >= 9 ? 'text-emerald-500' : parseFloat(res.mediaFinal) >= 7 ? 'text-indigo-500' : 'text-red-500'}`}>
                                                {res.mediaFinal}
                                            </span>
                                        </div>
                                        <div className="bg-white p-4 md:p-6 rounded-[20px] border border-slate-200/60 shadow-sm flex flex-col justify-between">
                                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Maior Nota</span>
                                            <span className="text-xl md:text-2xl font-bold text-indigo-600">{maiorNota}</span>
                                        </div>
                                        <div className="bg-white p-4 md:p-6 rounded-[20px] border border-slate-200/60 shadow-sm flex flex-col justify-between">
                                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Menor Nota</span>
                                            <span className="text-xl md:text-2xl font-bold text-rose-500">{menorNota}</span>
                                        </div>
                                    </div>

                                    {/* BOTÕES DO DOSSIÊ MOVIDOS PARA CIMA */}
                                    <div className="flex flex-col sm:flex-row items-center gap-4 mb-8 pb-8 border-b border-slate-200">
                                        <button 
                                            onClick={() => {
                                                setSelectedDossieRes({ res, maiorNota, menorNota });
                                                setShowDossieModal(true);
                                            }}
                                            className="w-full sm:w-1/2 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-bold shadow-md flex items-center justify-center gap-2 transition-colors"
                                        >
                                            <PrinterIcon className="w-5 h-5"/> Imprimir Dossiê Geral
                                        </button>
                                        <button 
                                            onClick={() => handleExportTeacherData(res)} 
                                            className="w-full sm:w-1/2 py-3 rounded-xl border-2 border-slate-200 text-sm font-bold text-slate-600 hover:text-slate-800 hover:bg-slate-50 flex items-center justify-center gap-2 transition-colors"
                                        >
                                            <DownloadIcon className="w-5 h-5"/> Exportar Dados
                                        </button>
                                    </div>

                                    <h4 className="text-sm font-bold text-slate-800 uppercase tracking-wider mb-6 flex items-center gap-2">
                                        <ChartIcon /> Detalhamento por Resposta
                                    </h4>
                                    
                                    <div className="space-y-4 mb-8">
                                        {res.avaliacoes.map((av, idx) => (
                                            <div key={av.id || idx} onClick={(e) => toggleAssessmentAccordion(av.id || idx, e)} className={`bg-white p-4 md:p-6 rounded-[20px] border shadow-sm flex flex-col justify-between cursor-pointer transition-all ${expandedAssessmentId === (av.id || idx) ? 'border-indigo-400 ring-4 ring-indigo-50' : 'border-slate-200/60 hover:border-indigo-200'}`}>
                                                <div className="flex justify-between items-center">
                                                    <div className="flex items-center gap-3 md:gap-4">
                                                        <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center font-bold text-xs md:text-sm ${expandedAssessmentId === (av.id || idx) ? 'bg-indigo-100 text-indigo-700' : 'bg-slate-100 text-slate-500'}`}>
                                                            #{idx + 1}
                                                        </div>
                                                        <div>
                                                            <span className="block text-sm font-bold text-slate-700">Cadete (Anônimo)</span>
                                                            <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider">RE Oculto • {av.aluno_pelotao || 'Sem Pelotão'}</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-3">
                                                        {expandedAssessmentId === (av.id || idx) && (
                                                            <button 
                                                                onClick={(e) => { 
                                                                    e.stopPropagation(); 
                                                                    handlePrintIndividualReport(res, av, e.shiftKey); 
                                                                }} 
                                                                className="text-slate-400 hover:text-indigo-600 bg-slate-100 hover:bg-indigo-50 p-2 rounded-lg transition-colors"
                                                                title="Imprimir Relatório Individual (Segure Shift para Revelar Cadete)"
                                                            >
                                                                <PrinterIcon className="w-4 h-4"/>
                                                            </button>
                                                        )}
                                                        <span className={`px-3 py-1.5 md:px-4 md:py-1.5 text-[10px] md:text-xs font-bold rounded-lg ${Number(av.nota_geral) >= 9 ? 'bg-emerald-50 text-emerald-600' : Number(av.nota_geral) >= 7 ? 'bg-indigo-50 text-indigo-600' : 'bg-red-50 text-red-600'}`}>
                                                            Nota: {av.nota_geral}
                                                        </span>
                                                    </div>
                                                </div>
                                                
                                                {expandedAssessmentId !== (av.id || idx) && av.comentarios_gerais && (
                                                    <p className="text-sm text-slate-500 mt-4 italic line-clamp-1 border-l-2 border-indigo-200 pl-3">"{av.comentarios_gerais}"</p>
                                                )}

                                                {expandedAssessmentId === (av.id || idx) && (
                                                    <div className="mt-6 pt-6 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
                                                        {/* AS 7 PERGUNTAS DO BD */}
                                                        {renderProgressBar('Conhecimento da Matéria', av.conhecimento_materia)}
                                                        {renderProgressBar('Desempenho como Prof.', av.desempenho_professor)}
                                                        {renderProgressBar('Cap. de Comunicação', av.capacidade_comunicacao)}
                                                        {renderProgressBar('Motiva a Participação', av.motiva_participacao)}
                                                        {renderProgressBar('Preparação das Aulas', av.preparacao_aulas)}
                                                        {renderProgressBar('Postura em Sala', av.postura_sala)}
                                                        {renderProgressBar('Relacionamento', av.relacionamento_interpessoal)}
                                                        
                                                        {av.comentarios_gerais && (
                                                            <div className="col-span-1 sm:col-span-2 mt-4 bg-slate-50 p-5 rounded-xl border border-slate-100">
                                                                <span className="block font-bold text-slate-400 text-[10px] mb-2 uppercase tracking-wider">Comentários / Sugestões</span>
                                                                <p className="text-slate-600 italic text-sm leading-relaxed">"{av.comentarios_gerais}"</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                        {res.avaliacoes.length === 0 && <p className="text-center text-slate-400 text-sm">Nenhuma avaliação encontrada.</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })()}

            </main>

            {/* ====================== MODAIS ====================== */}
            <Modal show={showModal} onClose={() => setShowModal(false)} title="Novo Ciclo de Avaliação">
                <form onSubmit={handleCreateCiclo} className="space-y-6 px-2">
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Título do Ciclo</label>
                        <input value={formCiclo.titulo} onChange={e => setFormCiclo({ ...formCiclo, titulo: e.target.value })} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-medium text-slate-700" required />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Data de Início</label>
                            <input type="date" value={formCiclo.data_inicio} onChange={e => setFormCiclo({ ...formCiclo, data_inicio: e.target.value })} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-medium text-slate-700" required />
                        </div>
                        <div>
                            <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Encerramento</label>
                            <input type="date" value={formCiclo.data_fim} onChange={e => setFormCiclo({ ...formCiclo, data_fim: e.target.value })} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-medium text-slate-700" required />
                        </div>
                    </div>

                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Curso</label>
                        <select value={formCiclo.curso_nome} onChange={e => setFormCiclo({ ...formCiclo, curso_nome: e.target.value, professores_ids: [] })} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-medium text-slate-700" required>
                            <option value="">Selecione o curso para filtrar professores...</option>
                            {cursosDisponiveis.map(curso => <option key={curso} value={curso}>{curso}</option>)}
                        </select>
                    </div>

                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Turma Alvo</label>
                        <select value={formCiclo.turma_id} onChange={e => setFormCiclo({ ...formCiclo, turma_id: e.target.value })} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-medium text-slate-700" required>
                            <option value="">Selecione a turma que fará a avaliação...</option>
                            {turmas.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                        </select>
                    </div>
                    
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Professores para Avaliar</label>
                        <div className="max-h-52 overflow-y-auto border border-slate-200/60 rounded-xl p-4 bg-slate-50/50 space-y-2 shadow-inner">
                            {!formCiclo.curso_nome && (
                                <p className="text-sm text-slate-400 font-medium text-center py-4">Selecione um curso acima para ver os professores.</p>
                            )}
                            {formCiclo.curso_nome && professoresFiltrados.length === 0 && (
                                <p className="text-sm text-red-400 font-medium text-center py-4">Nenhum professor encontrado dando aula neste curso.</p>
                            )}
                            
                            {professoresFiltrados.map(p => {
                                const materiasDoCurso = p.aulas.filter(aula => aula.curso_nome === formCiclo.curso_nome).map(aula => aula.materia_nome).join(' / ');
                                const isOcupado = profsOcupadosNoCurso.has(`${p.id}_${formCiclo.curso_nome}`) || profsOcupadosNoCurso.has(`${p.id}_legacy`);

                                return (
                                    <label key={p.id} className={`flex items-center gap-4 p-3.5 rounded-xl border transition-all ${isOcupado ? 'bg-slate-100 opacity-60 cursor-not-allowed border-slate-200' : 'bg-white cursor-pointer hover:border-indigo-300 border-slate-200 shadow-sm'}`}>
                                        <input type="checkbox" 
                                            checked={formCiclo.professores_ids.includes(p.id)}
                                            disabled={isOcupado} 
                                            onChange={e => {
                                                if (e.target.checked) setFormCiclo(prev => ({ ...prev, professores_ids: [...prev.professores_ids, p.id] }));
                                                else setFormCiclo(prev => ({ ...prev, professores_ids: prev.professores_ids.filter(id => id !== p.id) }));
                                            }} className="w-5 h-5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 disabled:opacity-50" />
                                        
                                        <div className="flex flex-col flex-1">
                                            <span className="font-bold text-slate-800 text-sm">{p.nome_completo} <span className="text-slate-400 font-bold text-[10px] uppercase ml-1">({p.posto})</span></span>
                                            <span className="text-[11px] text-slate-500 font-semibold mt-0.5">{materiasDoCurso}</span>
                                        </div>

                                        {isOcupado && <span className="text-[9px] bg-amber-100 text-amber-700 px-2 py-1 rounded-md font-bold uppercase tracking-wider">Em Ciclo</span>}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex justify-end pt-4 border-t border-slate-100">
                        <Button type="submit" variant="primary" disabled={processing || formCiclo.professores_ids.length === 0} className="px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold shadow-md">
                            Criar Novo Ciclo
                        </Button>
                    </div>
                </form>
            </Modal>

            <Modal show={showEditCicloModal} onClose={() => setShowEditCicloModal(false)} title="Prorrogar Prazo do Ciclo">
                <form onSubmit={handleEditPrazo} className="space-y-6 px-2">
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Ciclo Selecionado</label>
                        <input value={editCicloData.titulo} disabled className="w-full bg-slate-100 border border-slate-200 rounded-xl px-4 py-3 shadow-sm text-slate-500 font-medium" />
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-2">Nova Data de Encerramento</label>
                        <input type="date" value={editCicloData.data_fim} onChange={e => setEditCicloData({ ...editCicloData, data_fim: e.target.value })} className="w-full bg-white border border-slate-300 rounded-xl px-4 py-3 shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all font-medium text-slate-700" required />
                    </div>
                    <div className="flex justify-end pt-4 border-t border-slate-100">
                        <Button type="submit" variant="primary" disabled={processing} className="px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold shadow-md">
                            Salvar Alteração
                        </Button>
                    </div>
                </form>
            </Modal>

            <Modal show={showCommentsModal} onClose={() => setShowCommentsModal(false)} title={`Comentários - ${selectedCursoResult || 'Geral'}`} size="2xl">
                <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                    {comentariosFiltrados.length === 0 ? (
                        <div className="text-center text-slate-400 py-12">
                            <ChatIcon className="w-12 h-12 mx-auto mb-4 text-slate-300" />
                            <p className="font-medium">Nenhum comentário por escrito registrado para estes filtros.</p>
                        </div>
                    ) : (
                        comentariosFiltrados.map((coment) => (
                            <div key={coment.id} className="bg-slate-50 border border-slate-200/60 p-6 rounded-[20px]">
                                <div className="flex justify-between items-start mb-3">
                                    <h4 className="font-bold text-slate-800">{coment.professor}</h4>
                                    <div className="flex items-center gap-3">
                                        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{coment.data}</span>
                                        <span className={`px-3 py-1 text-xs font-bold rounded-lg ${Number(coment.nota) >= 9 ? 'bg-emerald-100 text-emerald-700' : Number(coment.nota) >= 7 ? 'bg-indigo-100 text-indigo-700' : 'bg-red-100 text-red-700'}`}>
                                            Nota {coment.nota}
                                        </span>
                                    </div>
                                </div>
                                <p className="text-slate-600 italic text-sm border-l-4 border-indigo-300 pl-4 py-1 leading-relaxed">
                                    "{coment.comentario}"
                                </p>
                            </div>
                        ))
                    )}
                </div>
            </Modal>

            {/* MODAL DE OPÇÕES DO DOSSIÊ */}
            <Modal show={showDossieModal} onClose={() => setShowDossieModal(false)} title="Opções de Impressão do Dossiê">
                <div className="p-4 flex flex-col gap-4">
                    <p className="text-sm text-slate-600 mb-2">Deseja incluir os comentários descritivos dos cadetes no relatório final?</p>
                    
                    <button 
                        onClick={() => handlePrintDossie(selectedDossieRes.res, selectedDossieRes.maiorNota, selectedDossieRes.menorNota, true)}
                        className="w-full py-4 rounded-xl bg-indigo-50 border border-indigo-200 hover:bg-indigo-100 hover:border-indigo-300 transition-colors flex items-center justify-center gap-3 text-indigo-700 font-bold"
                    >
                        <ChatIcon className="w-5 h-5"/> Imprimir COM Comentários
                    </button>
                    
                    <button 
                        onClick={() => handlePrintDossie(selectedDossieRes.res, selectedDossieRes.maiorNota, selectedDossieRes.menorNota, false)}
                        className="w-full py-4 rounded-xl bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:border-slate-300 transition-colors flex items-center justify-center gap-3 text-slate-700 font-bold"
                    >
                        <DocumentIcon className="w-5 h-5"/> Imprimir SEM Comentários (Apenas Notas)
                    </button>
                </div>
            </Modal>

            {expandedImage && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4 animate-fade-in" onClick={() => setExpandedImage(null)}>
                    <div className="relative w-full max-w-2xl flex justify-center items-center">
                        <button className="absolute -top-12 right-0 md:-right-12 text-white hover:text-slate-300 transition-colors p-2" onClick={() => setExpandedImage(null)}>
                            <XIcon className="w-8 h-8" />
                        </button>
                        <img src={expandedImage} alt="Foto Expandida" className="rounded-[24px] shadow-2xl object-contain max-h-[85vh] w-auto bg-white border-4 border-white" onClick={(e) => e.stopPropagation()} />
                    </div>
                </div>
            )}
        </div>
    );
};